/**
 * @file: 自定义事件
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2023-09-26 19:06:42
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2024-01-18 14:25:23
 * @FilePath: /console-znzs/new_src/utils/events.js
 */
import {EventEmitter} from 'events';

const event = new EventEmitter();
event.setMaxListeners(1000);

export default event;

function createGroup(key) {
    function on(fn) {
        event.on(key, fn);
    }
    function emit(...args) {
        event.emit(key, ...args);
    }

    function off() {
        event.removeAllListeners(key);
    }
    return {
        on,
        emit,
        off,
    };
}

const {on: onTextChange, emit: emitText} = createGroup(Symbol('input-text-change'));
const {on: onCategoryChange, emit: emitCategory} = createGroup(Symbol('category-change'));
// 流式异常
const {on: onFrameError, emit: emitFrameError} = createGroup(Symbol('frame-error'));
// 停止流式生成
const {on: onStreamStop, emit: emitStreamStop} = createGroup(Symbol('stop-stream'));
// 流式生成完成
const {on: onStreamStart, emit: emitStreamStart, off: offStreamStart} = createGroup(Symbol('stream-start'));
// 流式生成完成
const {on: onStreamComplete, emit: emitStreamComplete, off: offStreamComplete} = createGroup(Symbol('stream-complete'));
// 消息发送环节
const {on: onSendQuestion, emit: emitSendQuestion, off: offSendQuestion} = createGroup(Symbol('send-question'));



export {
    onTextChange, emitText,
    onCategoryChange, emitCategory,
    onFrameError, emitFrameError,
    onStreamStop, emitStreamStop,
    onStreamStart, emitStreamStart, offStreamStart,
    onStreamComplete, emitStreamComplete, offStreamComplete,
    onSendQuestion, emitSendQuestion, offSendQuestion,
};

